export default __webpack_public_path__ + "static/media/5.fc3eabb3.jpg";